import { render, staticRenderFns } from "./AddOrUpdateDelivery.vue?vue&type=template&id=cc466646&scoped=true"
import script from "./AddOrUpdateDelivery.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateDelivery.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateDelivery.vue?vue&type=style&index=0&id=cc466646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc466646",
  null
  
)

export default component.exports